import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { Layout, Flex } from 'antd';

import BaseLayout from './components/BaseLayout/BaseLayout'

import Login from './pages/login/login'

import Home from './pages/home/home'
import Shop from './pages/shop/shop'
import ShopDetail from './pages/shopDetail/shopDetail'
import Science from './pages/science/science/science';
import Studies from './pages/science/studies/studies';

import Blog from './pages/aBout/Blog/Blog';
import ReviewsPage from './pages/aBout/Reviews/Reviews';
import Testimonials from './pages/aBout/Testimonials/Testimonials';
import Patents from './pages/aBout/Patents/Patents';

import ABoutDetail from './pages/aBoutDetail/aBoutDetail'

import './App.css';

const layoutStyle = {
  // overflow: 'hidden',
  width: '100%',
  maxWidth: '100%',
  background: '#fff'
};



function App() {
  const routerList = [{
    path:'/',
    element: <Home/>
  },{
    path:'/shop',
    element: <Shop/>
  },{
    path:'/shopDetail',
    element: <ShopDetail/>
  },{
    path:'/science',
    element: <Science/>
  },{
    path:'/studies',
    element: <Studies/>
  },{
    path:'/Blog',
    element: <Blog/>
  },{
    path:'/Reviews',
    element: <ReviewsPage/>
  },{
    path:'/Testimonials',
    element: <Testimonials/>
  },{
    path:'/Patents',
    element: <Patents/>
  },{
    path:'/aBoutDetail',
    element: <ABoutDetail/>
  }]
  

  return (
    <div className="App">
      <Flex gap="middle" wrap>
        <Layout style={layoutStyle}>
          <HashRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              
              <Route path="/" element={<BaseLayout />}> {/* 其他页面使用Layout */}
                {routerList.map((e,i)=>{
                  if(e.path === '/'){
                    return (
                      <Route key={i} index path={e.path} element={e.element}/>
                    )
                  }else{
                    return (
                      <Route key={i} path={e.path} element={e.element}/>
                    )
                  }
                })}
              </Route>
            </Routes>
          </HashRouter>
        </Layout>
      </Flex>
    </div>
  );
}

export default App;
